export type SortBy = 'relevance' | 'date';

export const SORT_CONFIG: Record<SortBy, { label: string; next: SortBy }> = {
  relevance: { label: 'По релевантности', next: 'date' },
  date: { label: 'По дате', next: 'relevance' },
};
